import {
  aCustomEntityType,
  aCustomEntityTypePage,
  CustomEntityType,
  mockCustomEntityTypesQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const getCustomEntityTypesQuery_create = (
  customEntityType: Partial<CustomEntityType>
) => {
  const customEntityTypes = aCustomEntityTypePage().objects;
  return mockCustomEntityTypesQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          customEntityTypes: aCustomEntityTypePage({
            objects: [
              ...customEntityTypes,
              aCustomEntityType({
                id: '0',
                ...customEntityType,
              }),
            ],
          }),
        },
      });
    }
  );
};

export const handlers = [
  mockCustomEntityTypesQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          customEntityTypes: aCustomEntityTypePage({
            objects: [
              aCustomEntityType({
                name: 'Custom Entity Type 1',
                identifier: 'custom-entity-type-1',
              }),
            ],
            total: 1,
            hasNextPage: false,
          }),
        },
      });
    }
  ),
];
